export default class StatusAtendimentoModel {
  constructor(private _name?: string, private _descricao: string = '') {}

  get name() {
    return this._name;
  }

  get descricao() {
    return this._descricao;
  }

  get analiseSolicitacaoFinalizada(): boolean {
    return "EM_ORCAMENTACAO" === this.name || this.possuiOrcamento;
  }

  get possuiOrcamento(): boolean {
    return "ORCAMENTO_FINALIZADO" === this.name;
  }
}

export const statusAtendimento: StatusAtendimentoModel[] = [
  new StatusAtendimentoModel("NOVO", "Novo"),
  new StatusAtendimentoModel("CONTRATADO", "Contratado"),
  new StatusAtendimentoModel("DESMARCADO", "Desmarcado"),
  new StatusAtendimentoModel("CANCELADO", "Cancelado"),
  new StatusAtendimentoModel("FINALIZADO", "Finalizado"),
  new StatusAtendimentoModel("PENDENTE_PAGAMENTO", "Pendente Pagamento"),
  new StatusAtendimentoModel("PENDENTE_PAGAMENTO_ADICIONAL", "Pendente Pagamento Adicional"),
  new StatusAtendimentoModel("ORCAMENTO_EXPIRADO", "Orçamento expirado"),
  new StatusAtendimentoModel("AGUARDANDO_AVALIACAO", "Aguardando Avaliação"),
  new StatusAtendimentoModel("ORCAMENTO_SOLICITADO", "Orçamento solicitado"),
  new StatusAtendimentoModel("RECUSADO_CENTRAL", "Solicitação de orçamento recusada"),  
  new StatusAtendimentoModel("RECUSADO_CLIENTE", "Orçamento recusado pelo cliente"),  
  new StatusAtendimentoModel("EM_ORCAMENTACAO", "Em orçamento pela central"),
  new StatusAtendimentoModel("ORCAMENTO_FINALIZADO", "Orçamento finalizado pela central"),
  new StatusAtendimentoModel("EM_APROVACAO_VALOR_ADICIONAL", "Em análise do valor adicional"),  
  new StatusAtendimentoModel("VALOR_ADICIONAL_RECUSADO", "Valor adicional recusado"),  
  new StatusAtendimentoModel("EM_APROVACAO_TRANSFERENCIA", "Em análise da transferência"),  
  
];
